import { render } from "./PopupCookie.vue?vue&type=template&id=972cdad8&scoped=true"
import script from "./PopupCookie.vue?vue&type=script&lang=js"
export * from "./PopupCookie.vue?vue&type=script&lang=js"

import "./PopupCookie.vue?vue&type=style&index=0&id=972cdad8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972cdad8"]])

export default __exports__